import { AbsgArrayHelper } from '@absg/angular-common';
import { DispenseItem } from '@absg/nim-client-shared';
import { MedOrderDispenseDetail } from 'shared.root/models/med-order-detail';

export class DispenseSelectedGroup {
  medOrderDetail?: MedOrderDispenseDetail;
  dispenseItems: DispenseItem[];
  selectedId: number;

  constructor(medOrderDetail?: MedOrderDispenseDetail, dispenseItems?: DispenseItem[], selectedId?: number);
  constructor(medOrderDetail: MedOrderDispenseDetail, dispenseItems: DispenseItem[], selectedId: number) {
    this.medOrderDetail = medOrderDetail;
    this.dispenseItems = dispenseItems;
    this.selectedId = selectedId;
  }

  isMedOrderGroup(): boolean {
    return this.medOrderDetail !== null;
  }

  getMedOrderId(): number {
    if (!this.medOrderDetail) { return null; }
    return this.medOrderDetail.getMedOrderId();
  }

  getComponentName(): string {
    if (!this.medOrderDetail) { return null; }
    return this.medOrderDetail.getComponentName();
  }

  getInstructions(): string {
    if (!this.medOrderDetail) { return null; }
    return this.medOrderDetail.getInstructions();
  }

  getDoseAmount(): number {
    if (!this.medOrderDetail) { return null; }
    return this.medOrderDetail.getMedOrderDoseAmount();
  }

  getDoseUnit(): string {
    if (!this.medOrderDetail) { return null; }
    return this.medOrderDetail.getMedOrderDoseUnit();
  }

  hasDispenseItemsAttached(): boolean {
    if (!this.dispenseItems) { return false; }
    return this.dispenseItems.length > 0;
  }

  removeDispenseItem(itemId: number): void {
    this.dispenseItems = AbsgArrayHelper.remove(this.dispenseItems, item => item.id === itemId);
  }

  getConfiguredAmount(): number {
    if (!this.dispenseItems) { return 0; }
    const amount = AbsgArrayHelper.sumBy(this.dispenseItems, item => (item.inventoryItem?.quantitySelected || 0));

    return amount;
  }
}
